import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
} from "@mui/material";
import CommonButton from "components/common-component/Button";
import DialogContentText from "@mui/material/DialogContentText";
import CloseIcon from "@mui/icons-material/Close";
import { ReactComponent as RejectIcon } from "assets/images/icons/reject.svg";
import { ReactComponent as ApproveIcon } from "assets/images/icons/approve.svg";
import { makeStyles } from "@mui/styles";

const useStyle = makeStyles((theme) => ({
  dialog: {
    [theme.breakpoints.down("md")]: {
      width: "50%",
    },
    width: "30%",
  },
  dialogContent: {
    display: "flex",
    gap: "10px",
    justifyContent: "center",
  },
  dialogContentText: {
    color: "#000",
    marginTop: 15,
  },
  dialogTitle: {
    marginBottom: 10,
  },
  hrCloseIcon:{
    position: "absolute",
    right: 0,
    top: 3,
    color:theme.palette.grey[500],
  },
  hrIconBtn:{
    textAlign: "center"
  },
  hrActionBtn:{
    justifyContent: "center"
  }
}));

const LeaveConfirmDialog = ({
  handleClose,
  open,
  handeleSubmit = () => {},
  approved,
  loading,
}) => {
  const classes = useStyle();
  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      classes={{ paper: classes.dialog }}
    >
      <DialogTitle className={classes.dialogTitle}>
        <IconButton
          aria-label="close"
          onClick={() => handleClose()}
          className={classes.hrCloseIcon}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Grid className={classes.hrIconBtn}>
          {approved === "approved" ? (
            <ApproveIcon width="150px" height="150px" />
          ) : (
            <RejectIcon width="150px" height="150px" />
          )}
        </Grid>
        <Grid className={classes.dialogContent}>
          <DialogContentText className={classes.DialogContentText}>
            {approved === "approved"
              ? "Are you sure you approve all leave"
              : "Are you sure you want to reject all leave"}
          </DialogContentText>
        </Grid>
      </DialogContent>
      <Divider />
      <DialogActions className={classes.hrActionBtn}>
        <CommonButton
          loading={loading}
          variant="contained"
          onClick={() => handeleSubmit(approved)}
        >
          {approved === "approved" ? "Yes approve all" : "Yes reject all"}
        </CommonButton>
        <CommonButton variant="outlined" onClick={() => handleClose()}>
          Cancel
        </CommonButton>
      </DialogActions>
    </Dialog>
  );
};

export default LeaveConfirmDialog;
